$(() => {
  document.addEventListener("click", (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const link = target.closest("a.new-window");
    if (!(link instanceof HTMLAnchorElement)) return;

    e.preventDefault();
    window.open(link.href, "_blank");
  });
});
